import React from 'react';
import PropTypes from 'prop-types';
import RangePickerHOC from 'components/widgets/dateRangePicker';
import momentPropTypes from 'react-moment-proptypes';

const RangePickerNights = (props) => {
    const {
        startDate,
        endDate,
        startDateId,
        endDateId,
        startDatePlaceholderText,
        endDatePlaceholderText,
        onFocus,
        showCalendar,
    } = props;

    return (
        <div className="d-flex">
            <button className="date-picker-btn position-relative col text-left col" type="button" id={startDateId} onClick={(e) => { onFocus('startDate'); showCalendar(e); }}>
                <span className="text-label">{ startDateId === 'dyn_departureDate' ? 'Departure' : 'Check-in'}</span>
                {(startDate && startDate.format('MM/DD/YYYY')) || startDatePlaceholderText}
            </button>
            <div className="date-picker-days-container d-flex flex-column justify-content-center text-center px-2 left-border col">
                <div className=""># of Nights</div>
                <div className="pb-1">{(startDate && endDate && endDate.diff(startDate, 'days')) || 0}</div>
            </div>
            <button className="date-picker-btn position-relative col text-left left-border" type="button" id={endDateId} onClick={(e) => { onFocus('endDate'); showCalendar(e); }}>
                <span className="text-label">{ endDateId === 'dyn_returnDate' ? 'Return' : 'Check-out' }</span>
                {(endDate && endDate.format('MM/DD/YYYY')) || endDatePlaceholderText}
            </button>
        </div>
    );
};

RangePickerNights.propTypes = {
    startDate: momentPropTypes.momentObj,
    endDate: momentPropTypes.momentObj,
    startDatePlaceholderText: PropTypes.string,
    endDatePlaceholderText: PropTypes.string,
    startDateId: PropTypes.string.isRequired,
    endDateId: PropTypes.string.isRequired,
    onFocus: PropTypes.func.isRequired,
    showCalendar: PropTypes.func.isRequired,
};

RangePickerNights.defaultProps = {
    startDate: null,
    endDate: null,
    startDatePlaceholderText: 'Start Date',
    endDatePlaceholderText: 'End Date',
};

export default RangePickerHOC(RangePickerNights);
